import api from '@/api/partnerBanks';

const state = {
  all: [],
  partnerBank: {},
};

const getters = {
  partnerBank: (state) => state.partnerBank,
  activePartnerBanks: (state) => state.all.filter((b) => b.status === 'ACTIVE'),
};

const actions = {
  getAllPartnerBanks: async (context) => {
    let d = (await api.getAllPartnerBanks()).data;
    context.commit('setAllPartnerBanks', d);
  },
  searchPartnerBanks: async (context, params) => {
    let d = (await api.searchPartnerBanks(params)).data;
    context.commit('setAllPartnerBanks', d);
    return d;
  },
  getPartnerBank: async (context, id) => {
    let d = (await api.getPartnerBank(id)).data;
    context.commit('setPartnerBank', d);
    return d;
  },
  postPartnerBank: async (context, bank) => {
    const result = (await api.postPartnerBank(bank)).data;
    context.commit('setPartnerBank', result);
    return result;
  },
  putPartnerBank: async (context, bank) => {
    const result = (await api.putPartnerBank(bank)).data;
    context.commit('setPartnerBank', result);
    return result;
  },
  deletePartnerBank: async (context, bank) => {
    await api.deletePartnerBank(bank);
    context.commit('deletePartnerBank', bank);
  },
  cashAmountUpdate: async (_context, { bankName, cashAmount }) => {
    const result = (await api.cashAmountUpdate(bankName, cashAmount)).data;
    return result;
  },
};

const mutations = {
  setAllPartnerBanks(state, banks) {
    state.all = banks;
  },
  setPartnerBank(state, bank) {
    state.partnerBank = Object.assign({}, bank);
  },
  deletePartnerBank(state, bank) {
    state.all = state.all.filter((b) => b.id !== bank.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
